var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"wrap"},[_c('video',{attrs:{"src":_vm.videoPath,"playsinline":"","autoplay":"","loop":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }